import React, { useState } from 'react';
import { Popover, message } from 'antd';
import DeleteIcon from 'assets/svgs/DeleteIcon';
import ExportIcon from 'assets/svgs/ExportIcon';
import { cloneListAction } from '../../Audience/Actions/listsActions';
import { useHistory } from 'react-router';
import EditIcon from 'assets/svgs/EditIcon';
import CloneIcon from 'assets/svgs/CloneIcon';
import { exportAudienceContactsAction } from 'modules/Audience/Actions/listDetailsActions';
import classNames from 'classnames';

type Props = {
  children: object,
  listId: number | string,
  isSearched: boolean,
  actionHandler: (listId: number) => void;
  listTotalContacts: number;
} & typeof defaultProps;

const defaultProps = {
};
const ListCardPopover = function ListCardPopover(props: Props) {
  const [openMenu, setOpenMenu] = useState<boolean>(false);
  const { children, listId, isSearched, actionHandler, listTotalContacts } = props;
  const history = useHistory();
  const location = history.location;
  const pathname = location.pathname;

  const handleCloseMenu = () => {
    setOpenMenu(!openMenu);
  };

  const popoverTitle = (
    <div className='title-div'>
      <span className='title-text edit-text' onClick={(e) => {
        handleClick(e);
        pathname.includes('/audiences/lists')
          ? history.push(`view?list_id=${listId}&see_all=true`)
          : history.push(`/audiences/view?list_id=${listId}`);
        handleCloseMenu();
      }}><EditIcon /> Edit List</span>
      <span className='title-text clone-text' onClick={(e) => {
        handleClick(e);
        if (listId) {
          cloneListAction(listId?.toString(), isSearched)
            .then(() => {
              // eslint-disable-next-line
              message.success({
                content: 'List has been cloned successfully.',
              });
            })
            .catch(() => {
              // eslint-disable-next-line
              message.error({
                content: 'Something went wrong.',
              });
            })
          handleCloseMenu();
        }
      }}> <CloneIcon />
        Clone List</span>
    </div>
  );

  const popoverContent = (
    <div className='content-div'>
      <span className={classNames('content-text export-text', { curserNot: listTotalContacts === 0 })} >
        <span
          className={classNames('export-list-inner', { disabled: listTotalContacts === 0 })}
          onClick={(e) => {
            if (listTotalContacts !== 0) {
              handleClick(e);
              exportAudienceContactsAction(listId?.toString(), "", "", "", true);
              handleCloseMenu();
            }
          }}>
          <ExportIcon />
          Export List
        </span>
      </span>
      <span className='content-text delete-text' onClick={(e) => {
        handleClick(e);
        actionHandler(listId as number);
        handleCloseMenu();
      }}>
        <DeleteIcon />
        Delete List
      </span>
    </div>
  );

  const handleClick = (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
    e.stopPropagation();
  };

  return (
    <Popover
      placement="leftTop"
      title={popoverTitle}
      content={popoverContent}
      trigger="click"
      open={openMenu}
      overlayClassName='list-card-popover'
      onOpenChange={handleCloseMenu}
      onClick={handleClick}
      getPopupContainer={() => document.querySelectorAll(".list-card-global")[0] as HTMLElement}
    >
      {children}
    </Popover>
  );
};
ListCardPopover.defaultProps = defaultProps;
export default ListCardPopover;